import { layoutMarginSmall, ProductButton } from '@issuu/silkscreen';
import React, { useContext } from 'react';
import styled from 'styled-components';

import { shouldShowAds } from '../../util/ads-utils';
import { AdsPixel, AdsSellwild } from '../Ads';
import DocumentContext from './DocumentContext';

const Root = styled.div`
    grid-area: explore;
    display: flex;
    flex-direction: column;
`;

const ExploreWrapper = styled.div`
    margin-inline: auto;
    margin-block: calc(${layoutMarginSmall} * 4);
    text-align: center;
`;

const ExploreButton: React.FC<{ href: string }> = ({ href, children }) => (
    <ExploreWrapper>
        <ProductButton
            onClick={() => window.open(href)}
            role="link"
            size="large"
            variant="secondary"
        >
            {children}
        </ProductButton>
    </ExploreWrapper>
);

export const Explore: React.FC = () => {
    const context = useContext(DocumentContext);
    return (
        <Root>
            {shouldShowAds({ context, ignoreLicense: true }) ? (
                <section aria-label="Advert">
                    <AdsSellwild />
                </section>
            ) : null}
            <ExploreButton href="/explore">Go explore</ExploreButton>
            {shouldShowAds({ context }) ? (
                <div aria-hidden>
                    <AdsPixel />
                </div>
            ) : null}
        </Root>
    );
};
